@if (vm$ | async; as vm) {
  @if (vm.active) {
    <button
      (click)="onToggleChecked($event)"
      [disabled]="(vm.canToggleChecked === false && vm.checked === false) || vm.downloadInProgress"
      class="bg-white"
      mat-icon-button
    >
      <mat-icon [class.text-primary]="vm.checked">
        {{ vm.checked ? 'check_box' : 'check_box_outline_blank' }}
      </mat-icon>
    </button>
  }
}
